import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared/api-response.model';
@Injectable({
  providedIn: 'root'
})
export class PeppolParticipantLookupService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'participants'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'participants'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'participants'
    this.httpClient = http;
  }

  lookupSmp(peppol_id: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/smp-lookup/login-ep?peppol_id=${peppol_id}`
    }
  
    // Get the headers from getHttpHeader
    const httpOptions = this.getHttpHeader(visa);
  
    // Add the Content-Type header
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
  
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }


  checkIsValid(iso6523Code: string, peppol_id: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/smp-lookup/check-is-valid/login-ep?iso6523Code=${iso6523Code}&peppol_id=${peppol_id}`
    }
  
    // Get the headers from getHttpHeader
    const httpOptions = this.getHttpHeader(visa);
  
    // Add the Content-Type header
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
  
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }

  getParticipantListBySearchWord(searchWord: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/smp-lookup/search-word/login-ep?searchWord=${searchWord}`
    }
    
    const httpOptions = this.getHttpHeader(visa);
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
  
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }

}
